import { AdminIcon, HelpIcon, HomeIcon, LogoutIcon } from '@components/icons';
import type { MenuExtendedItem } from '@components/sidebar/types';

import { ROUTES } from '@constants/routes';

export const SIDEBAR_HEAD_MENU: MenuExtendedItem[] = [
  {
    title: 'Главная страница',
    link: ROUTES.GENERAL,
    route: ROUTES.GENERAL,
    icon: <HomeIcon />,
  },
];

export const SIDEBAR_FOOTER_MENU_USER: MenuExtendedItem[] = [
  {
    title: 'Помощь',
    icon: <HelpIcon />,
    link: ROUTES.HELP_MANUAL,
    route: ROUTES.HELP_MANUAL,
  },
];
export const SIDEBAR_FOOTER_MENU_ADMIN: MenuExtendedItem[] = [
  {
    title: 'Администратор',
    icon: <AdminIcon />,
    link: ROUTES.ADMIN_USERS,
    route: ROUTES.ADMIN_USERS,
  },
];
export const SIDEBAR_FOOTER_MENU_END: MenuExtendedItem[] = [
  {
    title: 'Выход',
    icon: <LogoutIcon />,
    link: ROUTES.LOG_OUT,
    route: ROUTES.LOG_OUT,
  },
];

export const SIDEBAR_FOOTER_MENU_SLOTS = {
  list: {
    sx: {
      mt: 'auto',
    },
  },
};
